import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";
import Image from "next/image";
import renderHTML from "lib/render-html";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.divider,
    border: "none",
    minHeight: 165,
    height: "100%",
  },
  avatar: {
    marginBottom: theme.spacing(1),
  },
}));

interface ExamFormatCardProps {
  title: string;
  subTitle?: string;
  icon?: string;
}

const ExamFormatCard = ({ title, subTitle, icon }: ExamFormatCardProps) => {
  const classes = useStyles();
  return (
    <Card variant="outlined" className={classes.root}>
      <CardContent>
        <Avatar aria-label="exam-format" className={classes.avatar}>
          {icon && <Image src={icon} width={40} height={40} alt={title} />}
        </Avatar>
        <Typography variant="h5" component="h2" gutterBottom>
          {renderHTML(title)}
        </Typography>
        <Typography>{renderHTML(subTitle)}</Typography>
      </CardContent>
    </Card>
  );
};

export default ExamFormatCard;
